

export default {
  scrollToTop: true,
  async asyncData({ app, store, error }) {
    if (!process.server) return
  },
  name: 'bannerTop',
  props:{
    bannerTitle:{
      type:String,
      default:'home.homeBannerTitle'
    },
    bannerSubTitle:{
      type:String,
      default:'home.homeBannerSubTitle'
    },
    imgUrl:{
      type:String,
      default:require('~/static/images/home-banner.png')
    },
    headerClass: {
      type: String,
      default: 'banner-view-text'
    },
    mainheadClass: {
      type: String,
      default: ''
    }, 
    subheadClass: {
      type: String,
      default: ''
    },
    animation: {
      type: String,
      default: ''
    }
  },
  computed:{
    titleStr(){
      return this.$t(this.bannerTitle)
    },
    subTitleStr(){
      return this.$t(this.bannerSubTitle)
    },
  },
  components: {

  },
  data() {
    return {
      height: ''
    }
  },
  mounted() {

  },
  methods: {

  }
}
